// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ActivityEdusModal_wrapper__20lT8","addButton":"ActivityEdusModal_addButton__3jxJt"};